import { ReactNode } from 'react'
import { Logo } from '@/components/atoms/Logo'

interface AuthLayoutProps {
  children: ReactNode
}

export const AuthLayout = ({ children }: AuthLayoutProps) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary via-primary/90 to-primary/80 p-4">
      <div className="w-full max-w-md space-y-8">
        <div className="flex justify-center">
          <div className="bg-white p-4 rounded-2xl shadow-lg">
            <Logo />
          </div>
        </div>
        {children}
      </div>
    </div>
  )
}
